import auth from '../../auth-config.json'

export const environment = {
  useMocks: false,
  displayEmailInput: false,
  endpoint: 'https://imancrete-back-dev.fromscratch-apis.com',
  auth: auth
};
